import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';

import { ConnectionButton, ChannelStepLayout } from 'src/pages/channel/shared';

import { Form, Field } from 'src/components/hook-form';

import { useEmailStep3 } from '../hooks/useEmailStep3';

export function EmailStep3() {
  const {
    methods,
    onSubmit,
    signInBtnHandler,
    isNextDisabled,
    getProviderDisplayName,
    emailProviderType,
    isGoogleAccVerified,
    isMSAccVerified,
    watchedChannelName,
    isSubmitting,
    t,
  } = useEmailStep3();

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <ChannelStepLayout title="" subtitle="" isNextDisabled={isNextDisabled()}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Field.Text
              name="channelName"
              label={t('CHANNEL_NAME')}
              InputLabelProps={{ shrink: true }}
              placeholder={t('ENTER_CHANNEL_NAME_PLACEHOLDER')}
              fullWidth
            />
          </Grid>

          {emailProviderType === 'other_provider' ? (
            <Grid size={{ xs: 12, md: 6 }}>
              <Field.Text
                name="email"
                label={t('EMAIL_ADDRESS')}
                type="email"
                InputLabelProps={{ shrink: true }}
                placeholder={t('ENTER_EMAIL_ADDRESS')}
                fullWidth
              />
            </Grid>
          ) : (
            <Grid size={{ xs: 12 }}>
              <Stack spacing={2}>
                <ConnectionButton
                  label={`${t('SIGN_IN_WITH')} ${getProviderDisplayName()}`}
                  icon={
                    emailProviderType === 'google'
                      ? 'flat-color-icons:google'
                      : 'logos:microsoft-icon'
                  }
                  onClick={signInBtnHandler}
                  disabled={!watchedChannelName || isSubmitting}
                  isConnected={isGoogleAccVerified || isMSAccVerified}
                  successMessage={t('ACCOUNT_VERIFIED')}
                />
              </Stack>
            </Grid>
          )}
        </Grid>{' '}
      </ChannelStepLayout>
    </Form>
  );
}
